export default {
  Paused: 144,
  Expired: 150,
  CampaignUserPaused: 124,
  CampaignBudgetPaused: 126,
  CampaignBudgetUserPaused: 127,
  PrivacyPending: 137,
  TargetingTooNarrow: 139,
  Draft: 140,
  Active: 141,
  Deleted: 143,
};
